import Icon from "@ant-design/icons";

const MaidRoomSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M1487 4909 c-161 -38 -319 -198 -356 -360 -17 -73 -13 -190 9 -261
109 -352 554 -462 814 -202 265 265 148 711 -213 818 -59 17 -190 20 -254 5z
m275 -141 c172 -80 258 -273 198 -448 -41 -121 -119 -199 -241 -240 -167 -57
-352 19 -440 182 -33 60 -34 67 -34 168 0 125 17 171 91 250 87 93 155 121
284 117 67 -2 97 -8 142 -29z"
      />
      <path
        d="M227 4046 c-118 -43 -185 -145 -174 -266 10 -110 -9 -87 509 -617
302 -310 286 -301 368 -198 29 36 53 65 54 63 1 -2 -6 -597 -15 -1323 -15
-1143 -16 -1323 -3 -1342 27 -43 100 -104 154 -131 49 -24 67 -27 155 -27 89
0 106 3 156 28 31 15 78 49 104 75 l46 47 58 -56 c100 -97 237 -126 368 -77
80 30 172 121 202 201 l21 59 -6 954 c-4 525 -4 954 0 954 18 0 205 -137 214
-156 32 -68 123 -133 206 -148 29 -6 133 -72 375 -238 185 -127 337 -232 338
-233 1 0 -15 -23 -37 -49 -46 -55 -49 -78 -17 -109 13 -12 63 -60 111 -106
l89 -84 -2 -131 c-1 -90 3 -157 14 -211 64 -310 275 -525 580 -590 86 -18 126
-19 147 -3 48 38 828 903 828 918 0 10 -8 28 -18 40 -18 22 -19 22 -140 10
-145 -15 -355 -9 -467 15 -173 36 -377 121 -516 215 -35 24 -102 80 -149 125
-145 137 -179 165 -202 165 -14 0 -42 -22 -77 -60 l-56 -60 -315 216 c-173
119 -316 218 -318 219 -1 1 12 26 29 54 27 44 33 63 36 129 l4 77 -255 635
c-220 547 -260 639 -288 662 -41 35 -164 99 -248 129 -64 24 -69 24 -450 21
-418 -3 -514 -10 -590 -43 -62 -27 -133 -102 -177 -187 l-32 -62 -225 249
c-124 137 -233 252 -242 255 -27 10 -107 6 -147 -8z m169 -183 c39 -43 88 -98
110 -122 l39 -45 -62 42 c-79 54 -106 55 -132 5 -8 -16 -8 -28 0 -45 6 -13
116 -95 247 -185 130 -89 272 -186 314 -216 l78 -54 -71 -94 c-38 -52 -74 -94
-78 -94 -16 0 -641 650 -656 682 -32 67 -8 150 54 183 64 34 80 28 157 -57z
m1609 -145 c32 -6 103 -34 159 -62 l101 -51 247 -615 c259 -643 266 -666 234
-729 -29 -56 -36 -56 -128 9 -47 33 -89 67 -93 77 -3 10 -74 206 -156 437
-153 427 -164 456 -183 468 -20 13 -52 8 -69 -10 -15 -16 -17 -56 -19 -315
l-3 -298 -575 396 c-316 217 -579 401 -584 408 -12 18 51 152 95 201 19 22 54
49 79 60 47 21 16 20 741 34 53 1 122 -3 154 -10z m-260 -994 l350 -241 8
-997 c7 -971 7 -998 -12 -1034 -43 -84 -122 -132 -216 -132 -65 0 -104 17
-157 68 l-38 36 0 649 c0 649 -1 678 -34 699 -6 4 -35 8 -63 8 -40 0 -58 -5
-73 -20 -20 -20 -20 -33 -20 -675 l0 -654 -36 -37 c-98 -98 -252 -100 -353 -6
l-33 32 6 227 c3 126 11 660 16 1188 6 528 13 1042 16 1142 l6 183 142 -97
c77 -54 299 -206 491 -339z m550 -90 c35 -98 63 -180 61 -181 -1 -1 -32 18
-69 44 l-67 47 1 145 c0 80 3 141 5 135 3 -7 34 -92 69 -190z m1374 -1037 c29
-30 52 -60 50 -65 -2 -6 -37 -45 -78 -87 l-74 -76 -71 70 -71 71 79 79 c61 61
83 78 95 71 9 -5 40 -33 70 -63z m224 -186 c68 -47 242 -130 340 -163 153 -51
256 -68 444 -75 l171 -6 -196 -213 -196 -213 -50 6 c-90 9 -169 33 -245 74
-85 46 -118 47 -140 7 -14 -25 -14 -29 5 -55 26 -35 169 -108 243 -124 31 -7
61 -15 68 -18 8 -4 -17 -39 -70 -96 -93 -103 -93 -103 -221 -63 -183 57 -327
201 -391 389 -23 69 -29 107 -33 211 l-5 127 114 120 c63 66 115 121 117 121
2 0 22 -13 45 -29z"
      />
    </g>
  </svg>
);

const MaidRoomIcon = (props) => <Icon component={MaidRoomSvg} {...props} />;

export default MaidRoomIcon;
